import LogRocket from "logrocket"
import { getOrCreateAgentId } from "./lib/getOrCreateAgentId"
import Analytics from "analytics"

const analytics = Analytics({
  app: "druthers",
  plugins:
    // @ts-expect-error
    import.meta.env.MODE !== "development"
      ? []
      : [
          // ... your analytics integrations
        ],
})

// @ts-expect-error
if (import.meta.env.MODE !== "development") {
  LogRocket.init("ogbtjz/druthers")
  const id = getOrCreateAgentId()
  LogRocket.identify(id)
  analytics.identify(id)
}

export default analytics
